/**
 * The geometry of scrubbing something laid out in a straight line.
 *
 * The linear counterpart to noteRing.ts: a кружочек is seeked by circling its
 * ring, a voice message by running a finger along its waveform, and the one
 * computation in the second gesture — how far along a box a pointer is — lives
 * here for the same reason the arctangent does. A fraction wants a unit test,
 * and a unit test wants no DOM.
 *
 * The convention is 0 at the left edge growing to 1 at the right, which is what
 * both a percentage width and a `left: N%` knob multiply straight into.
 */

/** How far along the track a pointer is, clamped to the track's own ends. */
export function trackFraction(rect: { left: number; width: number }, clientX: number): number {
  // A track that has not been laid out yet has no answer to give; 0 is the one
  // that cannot move playback somewhere surprising.
  if (rect.width <= 0) return 0;
  return clamp((clientX - rect.left) / rect.width);
}

/**
 * How far one arrow key moves the playhead.
 *
 * The same 5% the кружочек's ring steps by. A tenth of a two-minute recording
 * is a step nobody can aim with, and a second is a step nobody can cross a
 * recording with — a proportion is the only unit that serves both.
 */
export const SCRUB_STEP = 0.05;

/** A fraction moved by one step and kept inside the track. */
export function nudge(fraction: number, delta: number): number {
  return clamp(fraction + delta);
}

function clamp(fraction: number): number {
  if (!Number.isFinite(fraction)) return 0;
  return Math.min(1, Math.max(0, fraction));
}
